import { useContext } from 'react';

import DocumentContext from '../../../../contexts/DocumentContext.context';
import ToolbarToggleButton from '../../../../components/header/toolbar/ToolbarToggleButton';
import { TERMINOLOGY } from '../../../../../../shared/i18n';

const InsertCaptionButton = () => {
  const { doc, editor, isImageMenuOpen, setIsImageMenuOpen, isTableMenuOpen, setIsTableMenuOpen } =
    useContext(DocumentContext);

  const closeMenus = () => {
    if (isImageMenuOpen) setIsImageMenuOpen(false);
    if (isTableMenuOpen) setIsTableMenuOpen(false);
  };

  const onClick = () => {
    closeMenus(); // hide first
    requestAnimationFrame(() => {
      editor?.chain().focus().insertCaptionCommand().run(); // then change selection
    });
  };

  return (
    <ToolbarToggleButton
      selector={false}
      onClick={onClick}
      disabled={doc.isBlock}
      tooltip={doc.isBlock ? `Not available for ${TERMINOLOGY.block.lower}!` : undefined}
    >
      Caption
    </ToolbarToggleButton>
  );
};

export default InsertCaptionButton;
